import React from 'react'

import './../css/Recipe.css'

class Recipe extends React.Component{

    render(){
        let recipe = this.props.recipe;
        let frozenTime = '';
        if(!recipe.frozenTime){ 
            frozenTime = null 
        }
        else if(recipe.frozenTime === 'N/A')
            frozenTime = ("Frozen Time: " + recipe.frozenTime)
        else
            frozenTime = ("Frozen Time: " + recipe.frozenTime + " Minutes")
        
        return (
            <div className="RecipeContainer">
                <h4>{recipe.name}</h4>
                <img src={recipe.picture}></img>
                <h5>{!recipe.time ? null : ("Time: " + recipe.time + " Minutes")}</h5>
                <h5>{!recipe.freshTime ? null : ("Fresh Time: " + recipe.freshTime + " Minutes")}</h5>
                <h5>{frozenTime}</h5>
                <h5>{!recipe.dryTime ? null : ("Dry Time: " + recipe.dryTime + " Minutes")}</h5>
                <h5>{!recipe.soakedTime ? null : ("Soaked Time: " + recipe.soakedTime + " Minutes")}</h5>
                <h5>{!recipe.ratio ? null : ("Water Ratio: " + recipe.ratio) + " (grain:water)"}</h5>
                <h5>Method: {recipe.method}</h5>
            </div>
        );
    }
}

export default Recipe;